import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Logo.module.css';

const Logo = ({ linkTo = "/", color = "default", size = "medium" }) => {
  const getColorClass = () => {
    if (color === "white") return styles["logo-color-white"];
    if (color === "primary") return styles["logo-color-primary"];
    return styles["logo-color-default"];
  };
  
  const getSizeClass = () => {
    if (size === "small") return styles["logo-size-small"];
    if (size === "large") return styles["logo-size-large"];
    return styles["logo-size-medium"];
  };
  
  return (
    <Link to={linkTo} className={`${styles["logo-container"]} ${getColorClass()} ${getSizeClass()}`}>
      <i className={`fas fa-qrcode ${styles["logo-icon"]}`}></i>
      <span className={styles["logo-text"]}>QR Butler</span>
    </Link>
  );
};

export default Logo;